module.exports = __webpack_public_path__ + "img/vdara.40744f1a.webp";